import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import "@/App.css";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Contact from "./pages/Contact";
import ServiceDetail from "./pages/ServiceDetail";
import ServiceForm from "./pages/ServiceForm";
import { Toaster } from "./components/ui/toaster";
import PageTracker from "./components/PageTracker";

// Lazy-load heavy private routes so the public bundle (Home / Contact / Services) is smaller
const Dashboard = lazy(() => import("./pages/Dashboard"));
const AdminPanel = lazy(() => import("./pages/AdminPanel"));
const ProductionChecklist = lazy(() => import("./pages/ProductionChecklist"));
const Checkout = lazy(() => import("./pages/Checkout"));
const PaymentSuccess = lazy(() => import("./pages/PaymentSuccess"));
const OrderConfirmation = lazy(() => import("./pages/OrderConfirmation"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const Faqs = lazy(() => import("./pages/Faqs"));
const AdminSop = lazy(() => import("./pages/AdminSop"));

const RouteFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-emerald-600" />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PageTracker />
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/admin/checklist" element={<ProductionChecklist />} />
            <Route path="/admin/sop" element={<AdminSop />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/service/:id" element={<ServiceDetail />} />
            <Route path="/service/:id/form" element={<ServiceForm />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/order/:orderId" element={<OrderConfirmation />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/faqs" element={<Faqs />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
